module.exports = __webpack_public_path__ + "img/hh4.d0bdd1ed.png";